export default {
    "ContactUs": {
        en: "Contact us at",
        es: "Contáctanos",
        pt: "Fale conosco"
    },
    "newsAndUpdates": {
        en: "For news and updates you can follow us on",
        es: "Para más noticias puedes seguirnos en",
        pt: "Para mais notícias você pode nos seguir no"
    },
    "andmailinglist": {
        en: "and also join our mailing list",
        es: "y también inscribirte en nuestro mailing list",
        pt: "e também inscrever-se na nossa mailing list"
    },
    "and": {
        en: "and",
        es: "y",
        pt: "e"
    },
    "* {firstName}": {
        en: "* First name",
        es: "* Nombre",
        pt: "* Nome"
    },
    "* {lastName}": {
        en: "* Last name",
        es: "* Apellido",
        pt: "* Sobrenome"
    },
    "* {email}": {
        en: "* Email",
        es: "* Dirección de correo",
        pt: "* Email"
    },
    "languagePref": {
        en: "* Language preference",
        es: "* Idioma de preferencia",
        pt: "* Idioma preferido"
    },
    "SEND": {
        en: "SEND",
        es: "ENVIAR",
        pt: "MANDAR"
    },
    "userAdded": {
        en: "Welcome :)",
        es: "Bienvenidx :)",
        pt: "Bem-vinde :)"
    },
    "serverError": {
        en: "Error, try again",
        es: "Error, inténtalo de nuevo por favor ",
        pt: "Erro, tente novamente por favor"
    },
    "userExists": {
        en: "User already exists!",
        es: "Usuario existente (ya te tenemos en nuestros registros!)",
        pt: "Usuario já existente (temos você em nossos registros!)"
    },
}
